import { render, staticRenderFns } from "./ReservinfoPage.vue?vue&type=template&id=4abf6fe6&scoped=true&"
import script from "./ReservinfoPage.vue?vue&type=script&lang=js&"
export * from "./ReservinfoPage.vue?vue&type=script&lang=js&"
import style0 from "./ReservinfoPage.vue?vue&type=style&index=0&id=4abf6fe6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abf6fe6",
  null
  
)

/* custom blocks */
import block0 from "./ReservinfoPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports